import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyBR3P5Ud82RCmxUqh7z7pHjBnEazgVD_6E',
  authDomain: 'chatty-me.firebaseapp.com',
  databaseURL: 'https://chatty-me.firebaseio.com',
  projectId: 'chatty-me',
  storageBucket: 'chatty-me.appspot.com',
  messagingSenderId: '679294523843',
  appId: '1:679294523843:web:fa56984a40c65639b58576',
  measurementId: 'G-1ZY9E20ZKK',
});

const auth = firebaseApp.auth();
const db = firebaseApp.firestore();

export { auth, db };
